const TracerApi3 =[
    {
        id:1,
        count:'755470',
        info:'Stag 2:00.41',
        leftPoint:'B12',
        rightPoint:'12',
        
    },
    {
        id:2,
        count:'755470',
        info:'Stag 2:00.41',
        leftPoint:'B12',
        rightPoint:'12',
        
    },
    {
        id:3,
        count:'755470',
        info:'Stag 2:00.41',
        leftPoint:'B12',
        rightPoint:'12',
        
    }
    ,
    {
        id:4,
        count:'755470',
        info:'Stag 2:00.41',
        leftPoint:'B12',
        rightPoint:'12',
        
    }
  
]
export default TracerApi3;